export default __webpack_public_path__ + "static/media/regimg-cards.7b225529.png";